const colors = {
    green: ['rgb(32, 115, 73)', 'rgb(43, 46, 67)', 'rgb(249, 216, 87)'],
    blue: ['rgb(156, 194, 197)', 'rgb(43, 46, 67)', 'rgb(249, 216, 87)']
};

document.querySelectorAll(".js-randomize").forEach(function (el) {
    const schema = colors[el.dataset.schema] || colors.green;

    el.innerHTML = el.textContent.replace(/\S/g, "<span>$&</span>");

    setInterval(function () {
        el.querySelectorAll("span").forEach(function (el) {
            const number = Math.floor(Math.random() * schema.length);
            el.style.color = schema[number];
        });
    }
    , 1000);
});